/**
 * Try `{ list, meta }` (or under `data`) for freight index-style payloads on the data-table route.
 */
function parseFreightListMetaTableShape(res) {
  const roots = [res, res?.data].filter((x) => x != null && typeof x === "object" && !Array.isArray(x));
  for (const r of roots) {
    let block = null;
    if (Array.isArray(r.list) && r.meta != null && typeof r.meta === "object") {
      block = r;
    } else if (r.data != null && typeof r.data === "object" && Array.isArray(r.data.list) && r.data.meta) {
      block = r.data;
    }
    if (!block) continue;
    const { list: rows, meta } = block;
    const m = meta;
    const recordsTotal = Number(m.total_count ?? m.records_total ?? m.grand_total) || 0;
    const recordsFiltered = Number(m.records_filtered ?? m.filtered_count ?? m.recordsFiltered) || 0;
    const draw = Number(m.draw ?? block.draw ?? res.draw) || 0;
    const rf = recordsFiltered || recordsTotal || rows.length;
    const rt = recordsTotal || rf || rows.length;
    return {
      draw,
      rows,
      recordsFiltered: rf,
      recordsTotal: rt
    };
  }
  return null;
}

/**
 * Freight user list (`/api/admin/freightUser/data`) — DataTables-style JSON,
 * either at the root or wrapped in `{ data: { … } }`, or `{ data: { list, meta } }`.
 */
export function parseFreightUserDataTable(res) {
  if (res == null || typeof res !== "object") {
    return { draw: 0, rows: [], recordsFiltered: 0, recordsTotal: 0 };
  }
  const listMeta = parseFreightListMetaTableShape(res);
  if (listMeta) return listMeta;

  const draw = Number(res.draw) || 0;
  const candidates = [res, res.data, res.data && res.data.data].filter(
    (x) => x != null && typeof x === "object" && !Array.isArray(x)
  );
  for (const c of candidates) {
    const rows = Array.isArray(c.data) ? c.data : Array.isArray(c.list) ? c.list : null;
    const rf = c.recordsFiltered ?? c.records_filtered;
    const rt = c.recordsTotal ?? c.records_total;
    if (rows != null || rf != null || rt != null) {
      const recordsFiltered = Number(rf) || 0;
      const recordsTotal = Number(rt) || 0;
      const safeRows = rows ?? [];
      return {
        draw: Number(c.draw) || draw,
        rows: safeRows,
        recordsFiltered: recordsFiltered || (safeRows.length ? safeRows.length : 0),
        recordsTotal: recordsTotal || recordsFiltered || (safeRows.length ? safeRows.length : 0)
      };
    }
  }
  return { draw, rows: [], recordsFiltered: 0, recordsTotal: 0 };
}

/**
 * Flatten DataTables server-side request params into `FormData` (Laravel-style keys).
 */
export function freightDataTablesParamsToFormData(params) {
  const fd = new FormData();

  function walk(key, val) {
    if (val === undefined) return;
    if (val === null) {
      fd.append(key, "");
      return;
    }
    if (typeof val === "object" && !(val instanceof Date) && !Array.isArray(val)) {
      Object.keys(val).forEach((sub) => walk(`${key}[${sub}]`, val[sub]));
      return;
    }
    if (Array.isArray(val)) {
      val.forEach((item, i) => walk(`${key}[${i}]`, item));
      return;
    }
    fd.append(key, String(val));
  }

  Object.keys(params).forEach((k) => walk(k, params[k]));
  return fd;
}
